import axios from 'axios';
import { DonationURL } from '../../../../config/UrlEndPoint';

export const URL = `${DonationURL}thk_period`;


// Get PeriodeKurban All For use Combobox data
export function getPeriodeKurbanAll() {
    return axios.get(URL);
}

export function getThkPeriodAll() {
    return axios.get(`${URL}/thk/periode`);
}

// //Get By ID
export function getPeriodeKurbanById(periodeKurbanId) {
    return axios.get(`${URL}/${periodeKurbanId}`);
}

// items => filtered/sorted result for table data
export function findPeriodeKurban(queryParams) {
    return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the periodeKurban on the server
export function createPeriodeKurban(periodeKurban) {
    return axios.post(URL, periodeKurban);
}

// UPDATE => PUT: update the periodeKurban on the server
export function updatePeriodeKurban(periodeKurban) {
    return axios.put(`${URL}/${periodeKurban.uuid}`, periodeKurban);
}

// UPDATE => Delete: Delete the periodeKurban on the server
export function deletePeriodeKurban(periodeKurban) {
    return axios.delete(`${URL}/${periodeKurban.uuid}`, periodeKurban);
}

export function changeStatusPeriodeKurban(uuid, status) {
    return axios.post(`${URL}/${uuid}/status`, { status: status });
}


